import {defineStore} from 'pinia'

export const useLayoutStore = defineStore('layout', {
    state: () => ({
        isSidebarOpen: false,
        wikiSidebarOpen: false,
        isSubheaderOpen: false,
        currentModule: null,
    }),

    actions: {
        setSidebarOpen(isSidebarOpen) {
            this.isSidebarOpen = isSidebarOpen
        },
        setWikiSidebarOpen(isWikiSidebarOpen) {
            this.wikiSidebarOpen = isWikiSidebarOpen
        },
        setCurrentModule(currentModule) {
            this.currentModule = currentModule
        },
    },
})
